export const GET_MEDIAS = "media/GET_MEIDAS";
export const GET_MEIDAS_PAGE = "media/GET_MEIDAS_PAGE";
const GET_MEDIA = "media/GET_MEDIA";
const DELETE_MEDIA = "media/DELETE";
//수정과 생성은 같은 메소드로 이용
export const POST_MEDIA = "media/POST";

export const getMedias = medias => ({
  type: GET_MEDIAS,
  medias
});

export const getMedia = media => ({
  type: GET_MEDIA,
  media
});

export const deleteMedia = () => ({
  type: DELETE_MEDIA
});

export const postMedia = () => ({
  type: POST_MEDIA
});

export default function media(
  state = { totalLength: 0, media: [], pageNumber: 1,loading: false },
  action
) {
  switch (action.type) {
    case GET_MEDIAS:
      return {
        ...state,
        totalLength: action.total_record,
        media: action.media
      };
    case GET_MEIDAS_PAGE:
      return {
        ...state,
        media: action.media,
        pageNumber: action.pageNumber
      };
    case GET_MEDIA:
      return state;
    case DELETE_MEDIA:
      return state;
    case POST_MEDIA:
      return state;
    default:
      return state;
  }
}
